import React, { useEffect, useState } from 'react';
import { Col, Form, Modal, Row, Table } from 'react-bootstrap';
import { Button, CircularProgress } from '@material-ui/core';
import { CloudUpload as UploadIcon } from '@material-ui/icons';

import Swal from 'sweetalert2';
import styled from 'styled-components';
import readUsersInfo from '../../../workers/read-file';
import fiterAPI from '../../../fiterAPI';

import validate from '../../../workers/file-validation';

const Td = styled.td`
  background-color: ${props =>
    props.error ? 'rgb(253, 176, 176) !important' : '#fffff'};
`;

const Tr = styled.tr`
  background-color: ${props =>
    props.fatalError ? 'rgb(199, 21, 21) !important' : '#fffff'};
`;

export default function SelfManagmentModal(props) {
  const { show, institutionId, setShow } = props;

  const [usersCount, setUsersCount] = useState(0);
  const [file, setFile] = useState(undefined);
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [allUsersList, setAllUsersList] = useState([]);
  const [usersWithError, setUsersWithError] = useState([]);
  const [usersWithCriticalError, setUsersWithCriticalError] = useState([]);
  const [showWithError, setShowWithError] = useState(false);
  const [usersRole, setUsersRole] = useState(false);

  useEffect(() => {
    setUsersList([]);
    async function fetchData() {
      const usrsCount = await fiterAPI.getActiveUsersCount(institutionId);
      // console.log(usrsCount);
      setUsersCount(usrsCount);
    }
    fetchData();
  }, [institutionId]);

  const handleFileChange = async event => {
    const sheet = event.target.files[0];
    setShowWithError(false);
    if (sheet) {
      const users = await readUsersInfo.readUsers(sheet);
      const data = validate.validateUsers(users);
      if (data.error) {
        alert(data.message);
        setUsersList([]);
      } else {
        setAllUsersList(data);
        setUsersList(data);
        setUsersWithError(data.filter(user => user.error));
        setUsersWithCriticalError(data.filter(user => user.fatalError));
      }
    }
  };

  function handlerFilterWithError() {
    setShowWithError(!showWithError);
    if (!showWithError) {
      setUsersList(usersWithError);
    } else {
      setUsersList(allUsersList);
    }
  }

  async function handlerSubmit() {
    if (!usersRole) {
      Swal.fire({
        title: 'Escolha o tipo de usuário para cadastrar.',
        icon: 'error'
      });
      return;
    }
    if (usersWithCriticalError.length > 0) {
      Swal.fire({
        title: 'Não foi possível registrar os usuários.',
        html:
          '<span> Existem erros críticos que precisam ser corrigidos. </span>',
        icon: 'error'
      });
      return;
    }
    setLoadingUpload(true);
    const apiResponse = await fiterAPI.importUsers({
      institutionId,
      role: usersRole,
      users: allUsersList
    });
    setLoadingUpload(false);

    if (!apiResponse.error) {
      Swal.fire({
        title: 'Usuários registrados com sucesso! .',
        html: `<span> Usuários cadastrados: ${apiResponse.createdUsers} </span>
            <br />
          <span> Usuários atualizados: ${apiResponse.updatedUsers} </span>
          `,
        icon: 'success'
      });
    } else {
      Swal.fire({
        title: 'Houve Um erro.',
        html: `<span> ${apiResponse.errorMessage} </span>`,
        icon: 'error'
      });
    }
  }

  return (
    <Modal size="xl" show={show} onHide={() => setShow(false)}>
      <Modal.Header closeButton />
      <Modal.Body>
        <Col md="5">
          <Row>Usuários ativos: {usersCount}</Row>
          <br />

          <Form.Group controlId="formFile" className="mb-3">
            <Form.Label>Selecione a planilha</Form.Label>
            <Form.Control
              accept=".xls, .xlsx"
              onChange={handleFileChange}
              type="file"
            />
          </Form.Group>
        </Col>
        <Col md="5">
          <select onChange={e => setUsersRole(e.target.value)}>
            <option value={false}>Selecione o tipo de usuário...</option>
            <option value="Colaborador">Colaborador</option>
            <option value="Student">Estudante</option>
          </select>
        </Col>
        <div>
          <span>
            {' '}
            Contagem de usuários: <b>{usersList.length}</b>{' '}
          </span>
          <br />
          <span>
            {' '}
            Usuários com erro: <b>{usersWithError.length}</b>{' '}
          </span>
          <br />
          <span>
            Usuários com erros críticos:{' '}
            <b> {usersWithCriticalError.length} </b>{' '}
          </span>

          <div>
            <input
              type="checkbox"
              checked={showWithError}
              onClick={handlerFilterWithError}
            />
            <span onClick={handlerFilterWithError}>
              Mostrar apenas usuários com erro.
            </span>
          </div>

          <Table responsive className="fixed-columns tableFixHead">
            <thead>
              <th>CPF</th>
              <th>Nome</th>
              <th>Area</th>
              <th>Cargo</th>
              <th>Unidade</th>
              <th>Telefone</th>
              <th>Nascimento</th>
              <th>Email</th>
            </thead>
            <tbody>
              {usersList.map(user => (
                <Tr key={user.cpf} fatalError={user?.fatalError}>
                  <Td error={user?.errors.cpf}>{user.cpf}</Td>
                  <Td error={user?.errors.name}>{user.name}</Td>
                  <Td error={user?.errors.area}>{user.area}</Td>
                  <Td error={user?.errors.course}>{user.course}</Td>
                  <Td error={user?.errors.unit}>{user.unit}</Td>
                  <Td error={user?.errors.phone}>{user.phone}</Td>
                  <Td error={user?.errors.birthday}>{user.birthday}</Td>
                  <Td>{user.email}</Td>
                </Tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          disabled={loadingUpload}
          onClick={handlerSubmit}
          variant="contained"
          color="primary"
        >
          {loadingUpload ? <CircularProgress /> : ''}
          Salvar
        </Button>
        <Button
          onClick={() => setShow(false)}
          variant="contained"
          color="secondary"
        >
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
